import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check, Layers } from "lucide-react";
import { api } from "../../lib/api";
import { GEALAN_SYSTEMS } from "../../data/about";

// Alleen bevestigde merken; een systeem krijgt pas een link als de profielpagina gepubliceerd is.
const usePublishedSlugs = () => {
  const [slugs, setSlugs] = useState([]);
  useEffect(() => {
    api.get("/profile-systems", { params: { manufacturer: "gealan" } }).then((r) => setSlugs((r.data || []).map((s) => s.slug))).catch(() => {});
  }, []);
  return slugs;
};

const Card = ({ eyebrow, title, children, testid }) => (
  <div className="card flex flex-col p-6 sm:p-8" data-testid={testid}>
    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-maas-soft text-maas"><Layers className="h-5 w-5" aria-hidden="true" /></span>
    <p className="mt-5 text-[12.5px] font-semibold uppercase tracking-[0.14em] text-gold">{eyebrow}</p>
    <h3 className="mt-1.5 text-[20px] font-semibold text-ink">{title}</h3>
    <div className="mt-3 flex flex-1 flex-col text-[15px] leading-relaxed text-slate-600">{children}</div>
  </div>
);

export const AboutSystems = () => {
  const live = usePublishedSlugs();
  return (
    <div className="grid gap-5 lg:grid-cols-2" data-testid="about-systems">
      <Card eyebrow="Kunststof kozijnen" title="Duitse GEALAN-profielsystemen" testid="about-systems-kunststof">
        <p>Voor kunststof kozijnen werken wij onder andere met profielsystemen van het Duitse GEALAN, waaronder:</p>
        <ul className="mt-4 grid gap-2">
          {GEALAN_SYSTEMS.map((s) => (
            <li key={s.slug} className="flex items-center gap-2.5 text-ink" data-testid={`about-system-${s.slug}`}>
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-maas-soft"><Check className="h-3.5 w-3.5 text-maas" aria-hidden="true" /></span>
              {live.includes(s.slug) ? <Link to={`/profielsystemen/${s.slug}`} className="font-semibold hover:text-maas hover:underline">{s.name}</Link> : <span className="font-semibold">{s.name}</span>}
            </li>
          ))}
        </ul>
        <p className="mt-4 text-[14px] text-slate-500">Welk systeem wij toepassen, hangt af van de gekozen uitvoering en de technische mogelijkheden van uw woning.</p>
        <Link to="/kunststof-kozijnen" className="mt-auto inline-flex items-center gap-1.5 pt-5 text-[15px] font-semibold text-maas hover:underline" data-testid="about-systems-kunststof-link">Meer over kunststof kozijnen <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>
      </Card>
      <Card eyebrow="Aluminium kozijnen en puien" title="Afgestemd op uw situatie" testid="about-systems-aluminium">
        <p>Wij leveren ook aluminium kozijnen, deuren en (hef)schuifpuien. Het profielsysteem stemmen wij af op de technische eisen van de opening en op uw wensen voor uitstraling, glasvlak en bediening.</p>
        <p className="mt-3">Welk systeem past, bespreken we tijdens het advies. In uw offerte staat precies welk systeem u krijgt.</p>
        <Link to="/aluminium-kozijnen" className="mt-auto inline-flex items-center gap-1.5 pt-5 text-[15px] font-semibold text-maas hover:underline" data-testid="about-systems-aluminium-link">Meer over aluminium kozijnen <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>
      </Card>
    </div>
  );
};
